module.exports = __webpack_public_path__ + "img/9788930316859.615b13e8.jpg";